/**
 * 部屋設定の定数定義
 */

// 部屋サイズプリセット
export const ROOM_PRESETS = [
    { id: '6jo', name: '6畳', width: 350, depth: 260, height: 240 },
    { id: '8jo', name: '8畳', width: 450, depth: 260, height: 240 },
    { id: '10jo', name: '10畳', width: 450, depth: 350, height: 240 },
    { id: 'custom', name: 'カスタム', width: 400, depth: 300, height: 240 },
]

// 部屋サイズの制限値
export const ROOM_SIZE_LIMITS = {
    width: { min: 200, max: 800 },
    depth: { min: 200, max: 800 },
    height: { min: 200, max: 400 },
}
